import "core-js/modules/es.regexp.exec.js";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
function _createForOfIteratorHelper(r, e) {
  var t = void 0 !== _Symbol && _getIteratorMethod(r) || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = function (r, a) {
      if (r) {
        var _context;
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = _sliceInstanceProperty(_context = {}.toString.call(r)).call(_context, 8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var tokenStorage = {};
export var isLocked = !1;
export function lock() {
  return !isLocked && (isLocked = !0, !0);
}
export function unlock() {
  isLocked = !1;
}
export var getTokenByKey = function (key) {
  return tokenStorage[key];
};
export var setToken = function (key, token) {
  tokenStorage[key] = token;
};
export var removeTokenByKey = function (key) {
  delete tokenStorage[key];
};
export var getAccessToken = function () {
  return getTokenByKey("accessToken");
};
export var getIdToken = function () {
  return getTokenByKey("idToken");
};
export var clear = function () {
  var _step,
    _iterator = _createForOfIteratorHelper(_Object$getOwnPropertyNames(tokenStorage));
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var propName = _step.value;
      delete tokenStorage[propName];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};